import { useCallback } from 'react';
import { useMutation } from '@apollo/client';

import { ACKNOWLEDGE_SERVICE_RUN_BRIEF } from '../../../common/graphql/serviceRun';

/**
 * "I've read the brief" for a service run (ServiceRunBrief and the driver day
 * actions). Returns [acknowledgeBrief(), { loading }]; errors are thrown to the caller.
 */
const useAcknowledgeServiceRunBrief = ({ serviceRunId, adminTraining = false }) => {
	const [acknowledgeBriefMutation, { loading }] = useMutation(ACKNOWLEDGE_SERVICE_RUN_BRIEF);

	const acknowledgeBrief = useCallback(() => acknowledgeBriefMutation({
		variables: {
			id: serviceRunId,
			...(adminTraining ? { adminTraining: true } : {}),
		},
	}), [acknowledgeBriefMutation, adminTraining, serviceRunId]);

	return [acknowledgeBrief, { loading }];
};

export default useAcknowledgeServiceRunBrief;
